import { z } from 'zod';
import { CuidSchema } from './crm.schemas.js';
import { MANUAL_BACKDATE_DAYS, MAX_MANUAL_MINUTES, TIMER_ENTITIES } from './timer.js';

/**
 * مخططات مؤقّت العمل.
 */

export const StartTimerSchema = z.object({
  entity: z.enum(TIMER_ENTITIES),
  entityId: CuidSchema,
  note: z.string().trim().max(300).optional(),
});
export type StartTimerInput = z.infer<typeof StartTimerSchema>;

/** الإيقاف يقبل ملاحظةً تُكتب وقت الإيقاف — حين يكون العمل ما زال في الذهن. */
export const StopTimerSchema = z.object({
  note: z.string().trim().max(300).optional(),
});
export type StopTimerInput = z.infer<typeof StopTimerSchema>;

export const TimeEntryQuerySchema = z.object({
  entity: z.enum(TIMER_ENTITIES),
  entityId: CuidSchema,
});
export type TimeEntryQuery = z.infer<typeof TimeEntryQuerySchema>;

/**
 * قيدٌ يدوي.
 *
 * لمن نسي أن يبدأ المؤقّت — وهو الغالب. ومنعُه يجعل المؤقّت يقيس من يتذكّره
 * وحده، فتصير أرقامه عن الذاكرة لا عن العمل.
 *
 * والتاريخ محدود بأسبوعين إلى الوراء: كتابةُ وقتٍ على شهرٍ مضى ليست تذكّرًا
 * بل تقديرًا، وتُدخل في التقارير رقمًا لا أحد يستطيع مراجعته.
 */
export const ManualEntrySchema = z.object({
  entity: z.enum(TIMER_ENTITIES),
  entityId: CuidSchema,
  minutes: z
    .number()
    .int()
    .min(1, 'أقلّ مدة دقيقة واحدة.')
    .max(MAX_MANUAL_MINUTES, `أقصى مدة ${MAX_MANUAL_MINUTES / 60} ساعة.`),
  /** بداية العمل — يُحسب انتهاؤه بجمع المدة إليها. */
  startedAt: z.coerce.date().refine(
    (d) => {
      const now = Date.now();
      const floor = now - MANUAL_BACKDATE_DAYS * 86_400_000;
      return d.getTime() >= floor && d.getTime() <= now;
    },
    { message: `التاريخ خارج المدى — من ${MANUAL_BACKDATE_DAYS} يومًا مضت وحتى الآن.` },
  ),
  note: z.string().trim().max(300).optional(),
});
export type ManualEntryInput = z.infer<typeof ManualEntrySchema>;
